<template>
  <div :class="['mainmissionhub', classspx]" :style="mainmissionhubstyle">
    <div :class="['widthcontainer', classspx]">
      <div v-if="classspx == 'mobile'" class="pagetitle">
        {{ lbl.mission.mission }}
      </div>
      <div
        v-if="storeinfo.ShowCheckInMission7Days && missionData.Name"
        :class="['dailylogincontainer', classspx]"
      >
        <img
          class="coin"
          :src="require('@/assets/images/Star_Gold.svg')"
          alt=""
        />
        <div v-if="missionData.Name" class="title">{{ missionData.Name }}</div>
        <div v-if="missionData.Description" class="text">
          {{ missionData.Description }}
        </div>
        <div class="week">
          <div
            v-for="(item, index) in dayarray"
            :key="item + index"
            class="day"
          >
            <div
              class="dayline"
              :class="{
                firstday: index == 0,
                lastday: index + 1 == dayarray.length,
              }"
            ></div>
            <div :class="['icontitle', item]">
              <img
                v-if="item == 'checkedin'"
                :src="require('@/assets/images/doneorg.svg')"
                alt=""
              />
            </div>
            <div :class="['title', item]">
              {{ lbl.mission.days }} {{ index + 1 }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="storeinfo.ShowCampaignEnterCodeBanner"
        :class="['entercodecontainer', classspx]"
        @click="goto('earnpoint')"
      >
        <img v-if="enterCodeImage" :src="enterCodeImage" alt="" />
      </div>
      <div
        v-if="storeinfo.ShowCampaignSurveyBanner"
        :class="['surveycontainer', classspx]"
        @click="gotolink(websiteSurvey)"
      >
        <img v-if="websiteSurvey && surveyImage" :src="surveyImage" alt="" />
      </div>
      <div
        v-if="storeinfo.ShowCampaignFriendGetFriendBanner && fgfData"
        :class="['getfriendscontainer', classspx]"
      >
        <div class="title">
          <div class="icon">
            <img src="@/assets/images/personadd.svg" fill="red" alt="" />
          </div>
          <div class="text">
            {{ lbl.fgf.invitemodal }}
            {{ lbl.fgf.togetmodal }}
            {{ lbl.fgf.pointmodal }}
          </div>
        </div>
        <div class="btnContainer">
          <button @click="goto('inviter')">
            {{ lbl.fgf.invitebtn }}
          </button>
        </div>
        <div class="seemore" @click="goto('invitedList')">
          <span>{{ lbl.fgf.seeinvitefriends }}</span>
        </div>
      </div>
      <div class="modalcheckin" :class="{ show: modalstate.checkin }">
        <img src="@/assets/images/arr016.svg" fill="red" alt="" />
        <div class="text">Checked in!</div>
      </div>
      <div
        class="modalgotpoint"
        :class="{ show: modalstate.gotpoint }"
        @click="modalState('gotpoint', false)"
      >
        <div class="modalinside">
          <div class="close" @click="modalState('gotpoint', false)">
            <img src="@/assets/images/close_gray.svg" alt="" />
          </div>
          <img src="@/assets/images/Star_Gold.svg" fill="red" alt="" />
          <div class="title">{{ lbl.mission.cong }}</div>
          <div class="point">
            +<span v-if="missionData.Points">{{ missionData.Points }}</span>
            {{ lbl.main.points }}
          </div>
          <div class="detail">{{ lbl.mission.from }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Account from '@/helper/AccountHelper'
import Cache from '@/helper/Cache.js'
import Vue from 'vue'
import _ from 'lodash'
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import BzbsDashboard from '@/core/Home/BzbsDashboard'
import Locale from '@/helper/Locale.js'
export default {
  name: 'Invited',
  mixins: [CommonMixin, ResponsiveMixin],
  props: {
    classspx: {
      type: String,
    },
    storeinfo: {
      type: Object,
    },
  },
  data() {
    return {
      KEY_COOKIE_LOCALE: 'BzbsLocale',
      mainmissionhubstyle: {
        backgroundImage: `url(${require('@/assets/images/missionhubbg.png')})`,
      },
      modalstate: { checkin: false, gotpoint: false },
      btnColor: '',
      btnBGColor: '',
      baseURL: Vue.bzbsConfig.bzbBlobUrl,
      local: 'th',
      missionData: {},
      dayarray: [],
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      point: '',
      banner: {
        EnterCode: {
          en: '',
          th: '',
        },
        Survey: {
          en: '',
          th: '',
          website: '',
        },
      },
      enterCodeImage: null,
      surveyImage: null,
      websiteSurvey: null,
      fgfData: null,
    }
  },
  created() {
    this.local = Locale.getLocale()
    this.getCustomerStore()
    this.getblobearncode()
    this.handleLanguage(true)
    this.handleshowFGF(false)
    this.handleFooter(true)
    this.handleLoading(false)
    this.getloginmission()
    this.getActiveFGF()
    if (this.classspx == 'pc') {
      this.handleFooter(false)
      this.mainmissionhubstyle = {}
    }
  },
  methods: {
    getActiveFGF() {
      this.fgfData = null
      this.handleLoading(true)
      BzbsDashboard.getFGFGenLink()
        .then(res => {
          console.log('getFGFGenLink', res.data.CrmPlusFriendGetFriend)
          if (res.data.CrmPlusFriendGetFriend) {
            this.fgfData = res.data.CrmPlusFriendGetFriend
            this.ReferralPoints = res.data.CrmPlusFriendGetFriend.ReferralPoints
            var toDay = Date.now()
            if (
              res.data.CrmPlusFriendGetFriend.ExpireDate * 1000 >= toDay &&
              res.data.CrmPlusFriendGetFriend.StatusId == 3
            ) {
              this.handleshowFGF(true)
              sessionStorage.setItem('handleshowFGF', 'false')
            } else {
              this.fgfData = false
              this.handleshowFGF(false)
              sessionStorage.setItem('handleshowFGF', 'false')
            }
          } else {
            this.fgfData = false
            this.handleshowFGF(false)
            sessionStorage.setItem('handleshowFGF', 'false')
          }
        })
        .catch(err => {
          this.fgfData = false
          this.handleshowFGF(false)
          sessionStorage.setItem('handleshowFGF', 'false')
          console.log(err)
        })
    },
    goback() {
      this.$router.go(-1)
    },
    gotoScanCode() {
      Account.gotoScan(true, 'earnpoint')
    },
    goto(page) {
      this.$router.push({
        name: page,
      })
    },
    shuffleToken(bzbtoken) {
      return (
        bzbtoken.substring(bzbtoken.length - 5, bzbtoken.length) +
        bzbtoken.substring(1, bzbtoken.length - 5)
      )
    },
    gotolink(link) {
      if (link) {
        var token = this.shuffleToken(
          Account.getCacheToken() ? Account.getCacheToken() : null,
        )
        let theme = 'CRMPlus'
        let Locale = Cache.get('BzbsLocale') == 'th' ? 1054 : 1033
        window.open(
          link +
            '&theme=' +
            theme +
            '&return_url=' +
            encodeURI(window.location.origin + '/home') +
            '&locale=' +
            Locale +
            '&token=' +
            token,
          '_self',
        )
        this.handleLoading(true)
      }
    },
    modalState(type, state) {
      this.modalstate[type] = state
    },
    checkin() {
      this.modalstate.checkin = true
      setTimeout(() => {
        this.modalstate.checkin = false
      }, 3000)
    },
    getloginmission() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsDashboard.getloginmission()
          .then(res => {
            this.handleLoading(false)
            if (res) {
              if (res.data) {
                this.dayarray = []
                this.missionData = {}
                let mission = 0
                _.filter(res.data, (item, index) => {
                  if (
                    item.Name.toLowerCase() == 'check in and get more point'
                  ) {
                    mission = index
                  }
                })

                this.missionData = res.data.filter(
                  item =>
                    item.Name.toLowerCase() == 'check in and get more point',
                )[mission]

                console.log('missionData : ', this.missionData)

                if (this.missionData) {
                  this.genDataMission(this.missionData)
                  resolve(res.data)
                } else {
                  this.missionData = []
                  resolve(true)
                }
              } else {
                this.missionData = []
                resolve(res)
              }
            } else {
              this.missionData = []
              resolve(true)
            }
          })
          .catch(error => {
            this.missionData = []
            this.handleLoading(false)
            resolve(error)
          })
      })
    },
    genDataMission(data) {
      if (data.MaxLevels <= 1) {
        let lastindex = data.Missions.length - 1
        let maxday = 0
        maxday = data.Missions[lastindex].Value
          ? data.Missions[lastindex].Value
          : 0
        let complete = data.Missions[lastindex].IsCompleted
          ? data.Missions[lastindex].IsCompleted
          : false
        let currnetday = 0
        currnetday = data.Missions[lastindex].Current
          ? data.Missions[lastindex].Current
          : 0
        Array.from(Array(maxday).keys()).forEach(day => {
          if (day + 1 <= currnetday) {
            this.dayarray.push('checkedin')
          } else if (day + 1 == currnetday + 1) {
            this.dayarray.push('currentday')
          } else {
            this.dayarray.push('')
          }
        })

        if (
          complete &&
          this.compareCurrentDate(localStorage.getItem('stampDateCheckIn'))
        ) {
          this.modalState('gotpoint', false)
        } else if (complete) {
          localStorage.setItem('stampDateCheckIn', new Date())
          this.modalState('gotpoint', true)
        } else {
          localStorage.removeItem('stampDateCheckIn')
        }
      } else {
        console.log('data.Missions.length : ', data.Missions.length)
        let last_index = data.Missions.length - 1
        let levelPlus = data.Level + 1

        let maxday = 0
        maxday = data.Missions[last_index].Value
          ? data.Missions[last_index].Value / levelPlus
          : 0
        let currnetday = 0
        if (data.Missions[last_index].Current < maxday) {
          currnetday = data.Missions[last_index].Current
            ? data.Missions[last_index].Current
            : 0
        } else {
          currnetday = data.Missions[last_index].Current
            ? data.Missions[last_index].Current % maxday
            : 0
        }
        Array.from(Array(maxday).keys()).forEach(day => {
          if (day + 1 <= currnetday) {
            this.dayarray.push('checkedin')
          } else if (day + 1 == currnetday + 1) {
            this.dayarray.push('currentday')
          } else {
            this.dayarray.push('')
          }
        })

        let mod = null
        mod = data.Missions[last_index].Current
          ? data.Missions[last_index].Current % maxday
          : null

        if (mod != null) {
          if (
            mod == 0 &&
            this.compareCurrentDate(localStorage.getItem('stampDateCheckIn'))
          ) {
            this.modalState('gotpoint', false)
          } else if (mod == 0) {
            localStorage.setItem('stampDateCheckIn', new Date())
            this.modalState('gotpoint', true)
          } else {
            localStorage.removeItem('stampDateCheckIn')
          }
        } else {
          localStorage.removeItem('stampDateCheckIn')
        }
      }
    },
    getblobearncode() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsDashboard.getblobearncode()
          .then(res => {
            this.handleLoading(false)
            this.banner = res.data.data

            if (this.banner.ShowCampaignEnterCodeBannerUrl) {
              this.enterCodeImage =
                this.banner.ShowCampaignEnterCodeBannerUrl +
                `?v=` +
                new Date().getTime()
            } else {
              if (this.local == 'th') {
                this.enterCodeImage =
                  this.banner.EnterCode.th + `?v=` + new Date().getTime()
              } else {
                this.enterCodeImage =
                  this.banner.EnterCode.en + `?v=` + new Date().getTime()
              }
            }

            if (this.banner.ShowCampaignSurveyBannerUrl) {
              this.surveyImage =
                this.banner.ShowCampaignSurveyBannerUrl +
                `?v=` +
                new Date().getTime()
            } else {
              if (this.local == 'th') {
                this.surveyImage =
                  this.banner.Survey.th + `?v=` + new Date().getTime()
              } else {
                this.surveyImage =
                  this.banner.Survey.en + `?v=` + new Date().getTime()
              }
            }
            if (this.banner.Survey.website) {
              this.websiteSurvey = this.banner.Survey.website
            }
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            resolve(error)
          })
      })
    },
    getCustomerStore() {
      this.handleLoading(true)

      return new Promise(resolve => {
        BzbsDashboard.getCustomerStore()
          .then(res => {
            this.handleLoading(false)
            this.genCustomerStore(res.data)
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            console.log('getCustomerStore error', error)
            resolve(error)
          })
      })
    },
    genCustomerStore(data) {
      this.backgroundColor = data.StoreDetail.ButtonColor
      this.textColor = data.StoreDetail.ButtonTextColor

      this.storeinfo.image_header = data.StoreDetail.CoverUrl
      this.storeinfo.image_logo = data.StoreDetail.LogoUrl
      this.storeinfo.businessName = data.StoreDetail.BusinessName
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/_mixin.scss';
$font-title-size: 16px;
$font-text-size: 12px;
$font-main-color: #424242;
$dropshadowmain: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
$bordermain: solid 1px #f5f5f5;

.mainmissionhub {
  padding: 16px 0 32px 0;
  background-repeat: no-repeat;
  background-size: 100% auto;

  &.pc {
    .widthcontainer {
      max-width: 100%;
    }
  }

  .widthcontainer {
    width: 100%;
    max-width: 512px;
    margin: 0 auto;

    &.pc {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    &.mobile {
      padding: 0 16px 0 16px;
    }
  }

  .pagetitle {
    font-size: 20px;
    font-weight: 500;
    color: #212121;
  }

  .dailylogincontainer {
    margin: 96px 0 16px 0;
    padding: 32px 16px 16px 16px;
    border-radius: 10px;
    box-shadow: $dropshadowmain;
    border: $bordermain;
    background-color: #fff;
    text-align: center;
    position: relative;

    &.pc {
      width: 100%;
    }

    .coin {
      position: absolute;
      left: 50%;
      top: -80px;
      transform: translateX(-50%);
    }

    .title {
      font-size: $font-title-size;
      font-weight: 600;
      color: $font-main-color;
    }

    .text {
      font-size: $font-text-size;
      color: $font-main-color;
    }

    .week {
      margin: 16px 0;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      position: relative;

      .day {
        z-index: 2;
        width: 14%;
        position: relative;
        min-width: 44px;
        max-width: 67px;

        .dayline {
          height: 2px;
          width: 100%;
          background-color: #ffd761;
          position: absolute;
          top: 12px;
          left: 50%;
          transform: translateX(-50%);

          &.firstday {
            width: 60%;
            right: 0;
            left: unset;
            transform: translateX(0);
          }

          &.lastday {
            width: 50%;
            left: 0;
            transform: translateX(0);
          }

          &.firstday.lastday {
            display: none;
          }
        }

        .icontitle {
          margin: 0 auto;
          width: 25px;
          height: 25px;
          border-radius: 50%;
          border: solid 1px #ffd761;
          background-color: #fafafa;
          position: relative;

          &.checkedin {
            border: solid 7px #ffd761;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 80%;
            }
          }

          &.currentday {
            background-color: #ffd761;
            position: relative;

            &::before {
              content: '';
              position: absolute;
              width: 37px;
              height: 37px;
              top: -7px;
              left: -7px;
              border-radius: 50%;
              background-color: transparent;
              border: dashed 2px #ffd761;
              animation: spin 5s linear infinite;
            }
          }
        }

        .title {
          margin-top: 16px;
          margin-bottom: 16px;
          font-size: 10px;
          font-weight: 500;
          color: #bdbdbd;

          &.currentday {
            color: #616161;
          }
        }
      }
    }

    .btncontainer {
      button {
        width: 100%;
        padding: 8px 16px;
        border-radius: 40px;
        border: solid 2px rgba(76, 175, 80, 0.2);
        background-color: #4caf50;
        font-size: $font-title-size;
        color: #fff;
        font-weight: 500;
      }
    }
  }

  .entercodecontainer,
  .surveycontainer {
    margin-top: 16px;
    border-radius: 10px;
    box-shadow: $dropshadowmain;
    overflow: hidden;
    cursor: pointer;

    &.pc {
      width: 48%;
    }

    img {
      width: 100%;
      max-height: 125px;
    }
  }

  .getfriendscontainer {
    border-radius: 10px;
    margin-top: 16px;
    padding: 16px;
    box-shadow: $dropshadowmain;
    border: $bordermain;
    background-color: #fff;

    &.pc {
      width: 48%;
    }

    .title {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 14px;

      .text {
        padding-top: 8px;
        font-size: $font-title-size;
      }
    }

    .btnContainer {
      font-size: $font-title-size;
      font-weight: 500;
      margin-top: 17px;

      button {
        border-radius: 40px;
        border: solid 1px #033a70;
        background-color: #fff;
        width: 100%;
        height: 45px;
        color: #033a70;
      }
    }

    .seemore {
      text-align: center;
      margin-top: 17px;
      color: #2196f3;
      font-size: $font-title-size;
      font-weight: 500;

      span {
        cursor: pointer;
      }
    }
  }

  .modalcheckin {
    position: fixed;
    top: 50%;
    left: 50%;
    visibility: hidden;
    opacity: 0;
    text-align: center;
    box-shadow: $dropshadowmain;
    transform: translate(-50%, -50%);
    width: 273px;
    padding: 30px;
    border-radius: 10px;
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    background-color: rgba(255, 255, 255, 0.5);
    transition: all 0.3s ease-in-out;
    z-index: 6;

    .text {
      font-size: $font-title-size;
      font-weight: 600;
      color: $font-main-color;
    }

    &.show {
      visibility: visible;
      opacity: 1;
    }
  }

  .modalgotpoint {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    visibility: hidden;
    opacity: 0;
    background-color: rgba(0, 0, 0, 0.8);
    transition: all 0.3s ease-in-out;
    z-index: 6;

    .modalinside {
      width: 343px;
      text-align: center;
      padding: 24px 16px;
      border-radius: 10px;
      background-color: #fff;
      position: relative;

      .title {
        font-size: 20px;
        font-weight: 500;
        color: $font-main-color;
      }

      .point {
        font-size: 40px;
        color: #212121;
      }

      .detail {
        font-size: 14px;
        color: #757575;
      }

      .close {
        position: absolute;
        top: 10px;
        right: 10px;
        color: #000;
      }
    }

    &.show {
      visibility: visible;
      opacity: 1;
    }
  }
}
</style>
